/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationFetchRequest {
    getFixupPrototypeFunction() { return PromptRecommendationFetchRequest.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationFetchRequest>): PromptRecommendationFetchRequest {
        let obj = Object.assign(new PromptRecommendationFetchRequest(), model);
        PromptRecommendationFetchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationFetchRequest>): PromptRecommendationFetchRequest {
        if (!model) return null;
        return PromptRecommendationFetchRequest.newInstance(<PromptRecommendationFetchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationFetchRequest) {
        if (!obj) return;

        models.PromptRecommendationFetchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationFetchRequest): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationFetchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service account the prompt belongs to
     */
    service_account_id: string;

    /**
     * Prompt ID to fetch the recommendation for; either this or sys_id is required
     */
    prompt_id: string;

    /**
     * Prompt analytics record ID to fetch the recommendation for; either this or prompt_id is required
     */
    sys_id: string;

}
